<div class="flex justify-between">
  <div class="flex-col">
    <div class="fw-600 fs-20 mat-subtitle-1 mb-2">{{'DB_DETAILS.BACKUP_DETAILS' | transloco}}</div>
    <div class="fw-500 fs-14 mat-body subtitle">{{data?.to?.fileName}}</div>
  </div>
  <mat-icon svgIcon="close" class="cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
</div>
<mat-divider class="neutral-2 mt-8 mb-8"></mat-divider>
<div class="flex">
  <div class="section">
    <div class="from-header fs-16 mat-subtitle-1 mb-0 pb-8 pt-8 pl-16 fs-600">{{'DB_DETAILS.BACKUP_FROM' | transloco}}</div>
    <div class="pl-16 pr-16 from-bg">
      <ng-container *ngFor="let field of fromFields; let last = last">
        <div class="mat-subtitle-1 mb-0 fs-14 fw-600">{{field?.name}}</div>
        <div [ngClass]="{'pb-8': last}" class="mat-body fs-14 fw-400 word">{{data.from[field?.key] || '-'}}</div>
        <mat-divider *ngIf="!last" class="neutral-2 mt-8 mb-8"></mat-divider>
      </ng-container>
    </div>
  </div>

  <div class="section ml-16">
    <div class="to-header fs-16 mat-subtitle-1 mb-0 pb-8 pt-8 pl-16 fs-600">{{'DB_DETAILS.BACKUP_TO' | transloco}}</div>
    <div class="pl-16 pr-16 to-bg">
      <ng-container *ngFor="let field of toFields; let last = last">
        <div class="mat-subtitle-1 mb-0 fs-14 fw-600">{{field?.name}}</div>
        <div [ngClass]="{'pb-8': last}" class="mat-body fs-14 fw-400 word">{{data.to[field?.key] || '-'}}</div>
        <mat-divider *ngIf="!last" class="neutral-2 mt-8 mb-8 to-divider"></mat-divider>
      </ng-container>
    </div>
  </div>
</div>